import React from 'react';
import { getSearchResult } from '../actions/searchAction';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import Header from '../components/HeaderComponent';
import { connect } from 'react-redux';
import "../styles/ProcurementPortalStyles.css";
import { Redirect } from 'react-router-dom';
import { fetchAllLeadsDesktop } from '../actions/followupActions';
import { followupTableColumns } from "../config/column_fields";
import Select from 'react-select';
import axios from 'axios';
import ReactTable from "react-table";
import url from '../config';

class FollowupDesktop extends Component {

    constructor() {
        super();
        this.state = {
            userObj: {},
            received: false,
            filterData: {}
        };
    }

    componentWillMount() {
        this.props.fetchAllLeadsDesktop();
        if (localStorage.getItem("userObj")) {
            let userObj = JSON.parse(localStorage.getItem("userObj"));
            this.setState({
                userObj
            })
        }
    }

    componentWillReceiveProps({ leadDataReceived }) {
        this.setState({ received: leadDataReceived })
    }

    multiSelectType = (name, options) => {
        return (
            <div className="form-group" style={{ width: '100%' }}>
                <Select
                    isMulti
                    isSearchable
                    onChange={(e) => { this.handleMultiSelectChange(e, name) }}
                    name={name}
                    options={options}
                />
            </div>
        )
    }

    handleMultiSelectChange = (e, name) => {
        console.log(e, name);
        this.setState({
            filterData: {
                ...this.state.filterData,
                [name]: (e || []).map(row => row.value)
            }
        })
    }

    onApplyFilter = () => {
        console.log(this.state.filterData);
        this.setState({ received: false })
        this.props.fetchAllLeadsDesktop(this.state.filterData);
    }

    downloadSAFile = async (QUOTE_ID) => {
        try {
            console.log(QUOTE_ID)
            let response = await axios.post(url.pathBackend + "sales/followup/getSaFileUrl", {
                qid: QUOTE_ID
            });
            let fileUrl = response.data;
            console.log(fileUrl);
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', `${QUOTE_ID}.pdf`);
            link.setAttribute('target', `_blank`);
            document.body.appendChild(link);
            link.click();
        }
        catch (error) {
            console.log("Error in downloadSAFile", error);
        }
    }

    render() {

        let { state, props } = this;

        return (
            <div>
                <Header />
                <div className={`container-fluid procurementMainDiv`}>
                    <div className="row leadtransferTopbarSection">
                        <div className="col-md-3">
                            <label>State</label>
                            {this.multiSelectType("states", (this.props.mapping.states || []).map(state => ({ label: state, value: state })))}
                        </div>
                        <div className="col-md-3">
                            <label>Responsible</label>
                            {this.multiSelectType("responsible", (this.props.mapping.responsibleOptions || []).map(emp => ({ label: emp, value: emp })))}
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-success leadTransferSubmitButton" onClick={(e) => { this.onApplyFilter() }}>Submit</button>
                        </div>
                    </div>
                    <ReactTable
                        filterable={true}
                        showPagination={true}
                        sortable={true}
                        data={this.props.leads}
                        columns={[ ...followupTableColumns, {
                            Header: 'SA File',
                            accessor: 'saFile',
                            Cell: row => {
                                return <button onClick={() => this.downloadSAFile(row.original.QUOTE_ID)} className='btn btn-sm btn-success'>Download</button>
                            }
                        } ]}
                        defaultSorted={[{ id: "id", desc: true }]}
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id])
                                .toLowerCase()
                                .indexOf(filter.value.toLowerCase()) > -1
                        }
                        defaultPageSize={20}
                        loading={!this.state.received}
                    />
                </div>
            </div>
        )
    }

}

function mapStateToProps({ followup }) {
    let { leads = [], mapping = {}, leadDataReceived = {} } = followup;
    return {
        leads,
        mapping,
        leadDataReceived
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult, fetchAllLeadsDesktop }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowupDesktop);